import { render, staticRenderFns } from "./BaseSearchAutocomplete.vue?vue&type=template&id=40b02072&scoped=true"
import script from "./BaseSearchAutocomplete.vue?vue&type=script&lang=js"
export * from "./BaseSearchAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./BaseSearchAutocomplete.vue?vue&type=style&index=0&id=40b02072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b02072",
  null
  
)

export default component.exports